<template>
    <el-row>
        <el-form 
            :label-width="labelWidth" 
            :inline="inline" 
            :model="bindForm"
            :rules="rules"
            v-item-ref="bindForm"
            ref="ruleForm">
            <template v-for="(el, index) in searchConfig">
            <el-col :span="(el.json && el.json.span) ? el.json.span : 8" :key="index">
                <el-form-item 
                    :label="el.name" 
                    :show-message="false"
                    :prop="(el.json && el.json.prop) ? (el.field + '.' + el.json.prop) : el.field">              
                    <!-- 时间组件 start -->
                    <template v-if="el.type == 'LyDatePicker'">
                        <ly-date-picker 
                            v-model="bindForm[el.field]" 
                            :width="width" 
                            :disabled="(el.json && el.json.disabled) ? el.json.disabled : false"
                            :type="(el.json && el.json.type) ? el.json.type : 'daterange'"
                            :is-today="el.json ? el.json.isToday : true">
                        </ly-date-picker>
                    </template>
                    <!-- 时间组件 end -->
                    <!-- 拉下选择器 start -->
                    <template v-else-if="el.type == 'LySelect'">
                        <ly-select 
                            :api="el.json.api || ''" 
                            :def-data="el.json.data || []"
                            :all="el.json.all" 
                            :def-one="el.json.defOne" 
                            :width="width" 
                            v-model="bindForm[el.field]">
                        </ly-select>
                    </template>
                    <!-- 拉下选择器 end -->
                    <!-- 输入框 start -->
                    <template v-else-if="el.type == 'ElInput'">
                        <template v-if="el.json && el.json.prop && el.json.prop.length > 0">
                            <el-input 
                                size="small"
                                v-model="bindForm[el.field][el.json.prop]" 
                                :style="{width: el.width || '220px'}" 
                                :placeholder="el.placeholder || el.name"
                                :disabled="el.json && el.json.disabled ? el.json.disabled : false">
                            </el-input>  
                        </template>
                        <template v-else>
                            <el-input 
                                v-model="bindForm[el.field]" 
                                :style="{width: el.width || '220px'}" 
                                size="small"
                                :placeholder="el.placeholder || el.name"
                                :disabled="el.json && el.json.disabled ? el.json.disabled : false">
                            </el-input>  
                        </template>
                    </template>
                    <!-- 输入框 end -->
                    <!-- switch 开关 start -->
                    <el-switch v-model="bindForm[el.field]" v-else-if="el.type == 'ElSwitch'"></el-switch>
                    <!-- switch 开关  end -->
                    <!-- 批次 start -->
                    <template v-else-if="el.type == 'LyBatch'">
                        <ly-batch v-model="bindForm[el.field]"></ly-batch>
                    </template>
                    <!-- 批次  end  -->
                    <!-- 信息搜索 start -->
                    <template v-else-if="el.type == 'LyAutoSearch'">
                        <ly-auto-search 
                            v-model="bindForm[el.field]"
                            :width="el.width || ''"
                            :placeholder="el.name"
                            :dropdown-width="el.json.width || ''"
                            :other="bindForm[el.json.other]"
                            :json="el.json"></ly-auto-search>
                    </template>
                    <!-- 信息搜索  end  -->
                    <!-- 一层绑定的输入框搜索 start -->
                    <template v-else-if="el.type == 'LyAutoSelect'">
                        <ly-auto-select 
                            v-model="bindForm[el.field]"
                            :width="el.width || null"
                            :json="el.json"
                            :watch-field="bindForm[el.json.watch]">
                        </ly-auto-select>
                    </template>
                    <!-- 一层绑定的输入框搜索  end -->
                    <!-- 自动搜索绑定值的输入框 start -->
                    <template v-else-if="el.type == 'LyQueryInput'">
                        <ly-query-input
                            v-model="bindForm[el.field]"
                            :width="el.width"
                            :json="el.json"
                            :placeholder="el.name"
                            :watch-field="bindForm[el.json.watch]"
                            :disabled="el.json && el.json.disabled ? el.json.disabled : false">
                        </ly-query-input>
                    </template>
                    <!-- 自动搜索绑定值的输入框 end -->
                    <!-- 数字输入 start -->
                     <template v-else-if="el.type == 'LyInputNumber'">
                        <ly-input-number 
                            v-model="bindForm[el.field]"
                            :placeholder="el.name"
                            :width="el.width || null"
                            :min="el.json && el.json.min"
                            size="small">
                        </ly-input-number>
                    </template>
                    <!-- 数字输入 end -->
                    <!-- 普通时间组件 start -->
                    <!-- <template v-else-if="el.type == 'ElDatePicker'">
                        <el-date-picker
                            v-model="bindForm[el.field]"
                            type="date"
                            style="width:220px"
                            placeholder="选择日期">
                        </el-date-picker>
                    </template> -->
                    <!-- 普通时间组件  end -->
                    <!-- 仓库组件 start -->
                    <template v-else-if="el.type == 'LySelectWarehouse'">
                        <ly-select-warehouse
                            v-model="bindForm[el.field]"
                            :width="el.width">
                        </ly-select-warehouse>
                    </template>
                    <!-- 仓库组件  end  -->                    
                    <!-- 直接显示文字 不做任何处理 start -->
                    <template v-else-if="el.type == 'text'">
                        {{bindForm[el.field]}}
                    </template>
                    <!-- 直接显示文字 不做任何处理  end  -->
                </el-form-item>
            </el-col>
            </template>
            <el-col :span="24" v-if="isSearch" class="tc">
            <!-- <el-form-item v-if="isSearch"> -->
                <el-button type="primary" @click="handleSearch" size="small">
                    <i class="fa fa-search"></i>&nbsp;搜&nbsp;索
                </el-button>
            <!-- </el-form-item> -->
            </el-col>
        </el-form>
    </el-row>
</template>
<script>
    import LyDatePicker from '@c/date_picker'
    import LySelect from '@c/select'
    import LyBatch from '@c/batch'
    import LyAutoSearch from '@c/auto-search'
    import LyInputNumber from '@c/input-number'
    import LySelectWarehouse from '@c/select-warehouse'
    import LyAutoSelect from '@c/auto-select'
    import LyQueryInput from '@c/query-input'
    export default {
        name: 'LySearchForm',
        components: {
            LyDatePicker, 
            LySelect,
            LyBatch,
            LyAutoSearch,
            LyInputNumber,
            LySelectWarehouse,
            LyAutoSelect,
            LyQueryInput
        },
        props: {
            inline: {
                type: Boolean,
                default: true
            }, // 是否水平排列
            width: {
                type: String,
                default: '220px'
            }, // 组件的宽度
            labelWidth: {
                type: String,
                default: '100px'
            }, // 标识的宽度
            isSearch: {
                type: Boolean,
                default: true
            }, // 是否保护搜索按钮
            rules: {
                type: Object,
                default: function () {
                    return {}
                }
            }, // 验证规则
            config: [String, Array], // 组件配置json字符串或是 数组列表
            value: {
                type: Object,
                default: function () {
                    return {}
                }
            }
        },
        data () {
            return {
                searchConfig: {}, // 搜索组件列表配置
                bindForm: {}, // 组件绑定的字段
                timerspace: 0, // 指令时间间隔的记录
                functionList: [] // 表单变化指令变化后的执行函数
            }
        },
        watch: {
            config () {
                this.initForm()
            },
            // '$route' () {
            //     this.bindForm = {}
            //     console.log('路由变黑')
            // }
        },
        mounted () {
            if (this.config) {
                this.initForm()
            }
        },
        methods: {
            /**
             * 根据搜索框的配置设置
             */
            initForm () {
                this.bindForm = {} // 初始化bindForm
                // this.resetForm()
                let obj = typeof this.config === 'string' ? JSON.parse(this.config) : this.config
                // 将搜索配置中绑定的字段，加入到form对象
                for (let i in obj) {
                    if (obj[i].type && obj[i].type === 'function') {
                        this.functionList.push(obj[i]['func'])
                    } else if (!this.bindForm.hasOwnProperty(obj[i]['field'])) {
                        this.setFieldValue(obj[i]['field'], obj[i]['default'])
                        // this.$set(this.bindForm, obj[i]['field'], obj[i]['default'])
                        // if (obj[i]['json'] && obj[i]['json']['prop']) {
                        //     this.$set(this.bindForm, obj[i]['field'], obj[i]['default'] || {})
                        //     // 获得du
                        //     let prop = obj[i]['json']['prop']
                        //     this.$set(this.bindForm, obj[i]['field'], obj[i]['default'])
                        // } else {
                        //     this.$set(this.bindForm, obj[i]['field'], obj[i]['default'] || '')
                        // }
                    }
                }
                this.searchConfig = obj
                // 设置value值
                this.$emit('input', this.bindForm)
            },
            /**
             * 搜索监听
             */
            handleSearch () {
                this.$emit('search')
            },
            /**
             * 表单的验证
             */
            validateForm () {
                let bool = true
                this.$refs['ruleForm'].validate((valid) => {
                    bool = valid
                })
                return bool
            },
            /**
             * 初始化绑定表单中的数据
             * @param  {[type]} data [description]
             * @return {[type]}      [description]
             */
            initBindFormData (data) {
                 for (let field in data) {
                    if (this.bindForm.hasOwnProperty(field)) {
                        data[field] = data[field] === 0 ? '0' : data[field] 
                        this.setFieldValue(field, data[field] || '')
                    }
                }
            },
            /**
             * 设置字段上的值
             * @param {[String]} field [字段名]
             * @param {[type]} value [值]
             */
            setFieldValue (field, value) {
                this.$set(this.bindForm, field, value)
            },
            resetForm () {
                this.$refs['ruleForm'].resetFields();
            }
        },
        // 指令
        directives : {
            'item-ref' : { // 监听bindform的变化
                deep : true,
                update : function (el, binding, vnode) {
                    let now = new Date().getTime()
                    if (now - vnode.context.timerspace > 200) { // 避免高频率的触发
                        // 清除定时器
                        if (vnode.context.timer) {
                            clearTimeout(vnode.context.timer)
                        }
                        // 配置中的函数调用
                        // 这里延时调用，避免指令多次触发的重复调用
                        vnode.context.timer = setTimeout(function () {
                            vnode.context.functionList.forEach(function (func) {
                                func(vnode.context.bindForm)
                            })
                        }, 500)
                        vnode.context.timerspace = now
                    }
                }
            }
        }
    }
</script>